import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientCreate } from '../../../backends/AppSyncClientCreate';
import GetMyEndpoint from '../../../q/create/GetMyEndpoint';
import UpdateImage from '../../../q/create/UpdateImage';
import GetMyApp from '../../../q/create/GetMyApp';
import GetMyApps from '../../../q/create/GetMyApps';
import SetAppImage from '../../../q/create/SetAppImage';
import DeleteEndpointImage from '../../../q/create/DeleteEndpointImage';
import Endpoint from '../../../modules/data/Endpoint';
import PublisherImageForm from '../../../components/forms/app/Image';
import AORTypes from '../../../types';

class PublisherImageEdit extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherImageEdit';

    this.onCancel = this.onCancel.bind(this);
    this.onDel = this.onDel.bind(this);
    this.onSetDefault = this.onSetDefault.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onCancel() {
    const { history, endpoint } = this.props;
    history.push(`/editendpoint/${endpoint.data.app}/${endpoint.data.uuid}`);
  }

  onSetDefault() {
    const {
      onSetImage, endpoint, image,
    } = this.props;

    onSetImage({
      uuidEndpoint: endpoint.data.uuid,
      uuidImage: image.uuid,
    });
  }

  onDel() {
    const {
      history, onDeleteImage, endpoint, image,
      getAnalyticsService,
    } = this.props;

    getAnalyticsService().report.event('imageDelAttempt', 'create');

    return onDeleteImage({
      uuidEndpoint: endpoint.data.uuid,
      uuidImage: image.uuid,
    }).then((result) => {
      getAnalyticsService().report.event('imageDelSuccess', 'create');
      history.push(`/editendpoint/${endpoint.data.app}/${endpoint.data.uuid}`);
      return result;
    });
  }

  async onSave(values) {
    const {
      history, onSave, endpoint, image,
      getAnalyticsService,
    } = this.props;

    getAnalyticsService().report.event('imageSaveAttempt', 'create');

    image.comment = values.comment;
    image.delay = Number.parseInt(values.delay, 10) || 0;

    endpoint.postProcess();
    for (let i = 0; i < endpoint.pp.images.length; i += 1) {
      if (endpoint.pp.images[i].uuid === image.uuid) {
        endpoint.pp.images[i] = image;
        break;
      }
    }
    endpoint.data.images = JSON.stringify(endpoint.pp.images);

    return onSave({
      uuidEndpoint: endpoint.data.uuid,
      uuid: image.uuid,
      comment: image.comment,
      delay: image.delay,
    }).then((_result) => {
      getAnalyticsService().report.event('imageSaveSuccess', 'create');
      history.push(`/editendpoint/${endpoint.data.app}/${endpoint.data.uuid}`);

      return null;
    });
  }

  render() {
    const {
      direction, image, position, user,
    } = this.props;

    if (!user) {
      return (
        <>
        </>
      );
    }

    return (
      <PublisherImageForm
        position={position}
        image={image}
        onCancel={this.onCancel}
        onDel={this.onDel}
        onSetDefault={this.onSetDefault}
        onSave={this.onSave}
        direction={direction}
      />
    );
  }
}

PublisherImageEdit.defaultProps = {
  // TODO(clairbee): Even though 'app' is always supplied, we need a temporary value before graphql finishes loading
  endpoint: new Endpoint(),
  image: {},
  position: null, // it's unset until it's autodetected
  user: null,
};

PublisherImageEdit.propTypes = {
  endpoint: PropTypes.instanceOf(Endpoint),
  image: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onSave: PropTypes.func.isRequired,
  onDeleteImage: PropTypes.func.isRequired,
  onSetImage: PropTypes.func.isRequired,
  // match: ReactRouterPropTypes.match.isRequired,
  position: AORTypes.Position,
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetMyEndpoint, {
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      const endpoint = Endpoint.createFromData(props.data.getMyEndpoint);
      console.log('loaded endpoint');
      console.log(endpoint);
      let image;
      if (endpoint !== undefined && endpoint.data !== undefined && endpoint.data !== null) {
        console.log(`searching for ${props.ownProps.match.params.imageUuid}`);
        endpoint.postProcess();
        endpoint.pp.images.forEach((i) => {
          console.log(`checking image ${i.uuid}`);
          if (i.uuid === props.ownProps.match.params.imageUuid) {
            image = i;
          }
        });
      }
      return { endpoint, image };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientCreate(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientCreate,
  }),
  graphql(DeleteEndpointImage, {
    props: (props) => ({
      onDeleteImage: ({
        uuidEndpoint,
        uuidImage,
      }) => props.mutate({
        variables: {
          uuidEndpoint,
          uuidImage,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyEndpoint,
        props: (p) => ({
          endpoint: Endpoint.createFromData(p.data.getMyEndpoint),
        }),
        variables: { uuid: props.match.params.uuid },
        client: AppSyncClientCreate(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientCreate(props.user),
    }),
  }),
  graphql(SetAppImage, {
    props: (props) => ({
      onSetImage: ({
        uuidEndpoint,
        uuidImage,
      }) => props.mutate({
        variables: {
          uuidEndpoint,
          uuidImage,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientCreate(props.user),
    }),
  }),
  graphql(UpdateImage, {
    props: (props) => ({
      onSave: (input) => props.mutate({
        variables: input,
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyEndpoint,
        props: (p) => ({
          endpoint: Endpoint.createFromData(p.data.getMyEndpoint),
        }),
        variables: { uuid: props.match.params.uuid },
        client: AppSyncClientCreate(props.user),
      }],
      // fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'no-cache',
      client: AppSyncClientCreate(props.user),
    }),
    // client: AppSyncClientCreate,
  })
)(PublisherImageEdit);
